// https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily/4770179#4770179
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
// const keys: Record<number, number> = { 37: 1, 38: 1, 39: 1, 40: 1 };
// const preventDefault = (
//   event: SyntheticEvent | WheelEvent | TouchEvent | KeyboardEvent,
// ) => {
//   event.preventDefault();
// };
// function preventDefaultForScrollKeys(event: KeyboardEvent) {
//   if (keys[event.keyCode]) {
//     preventDefault(event);
//     return false;
//   }
// }
// // call this to Disable
// export const disableScroll = () => {
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   // @ts-ignore
//   window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
//   window.addEventListener('wheel', preventDefault, { passive: false }); // modern desktop
//   window.addEventListener('touchmove', preventDefault, { passive: false }); // mobile
//   window.addEventListener('keydown', preventDefaultForScrollKeys, false);
// };
// // call this to Enable
// export const enableScroll = () => {
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   // @ts-ignore
//   window.removeEventListener('DOMMouseScroll', preventDefault, false);
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   // @ts-ignore
//   window.removeEventListener('wheel', preventDefault, { passive: false });
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   // @ts-ignore
//   window.removeEventListener('touchmove', preventDefault, { passive: false });
//   window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
// };
export var disableScroll = function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
        window.scrollTo(scrollLeft, scrollTop);
    };
};
export var enableScroll = function () {
    window.onscroll = null;
};
